export const INITIAL_STATE = {
  sound: '',
  presetId: 0,
  volume: 0.2,
};

export const SET_SOUND = 'SET_SOUND';
export const SET_PRESET = 'SET_PRESET';
export const SET_VOLUME = 'SET_VOLUME';
